import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import '../index.scss';
import userStore from '../../../Stores/User';
import { observer } from 'mobx-react';


const IosInstructions = observer(({app, feedUrl}) => {

// function IosInstructions({ app, feedUrl }) {
  const [copied, setCopied] = useState(false);
  const marginStyle = {
    margin: '0px 10px 30px 10px',
  };
  const showOnCopy = {
    display: !copied && 'none',
  };
  const renderCopy = () => {
    return (
      <div>
        <div>
          1. Copy your RSS URL:{' '}
          <CopyToClipboard text={feedUrl} onCopy={() => setCopied(true)}>
            <button className="copy-button">
              <span>{copied ? 'Copied!' : 'Copy'}</span>
            </button>
          </CopyToClipboard>
        </div>
        {app !== "Spotify" && <div style={{ display: (!copied || app === 'Other Apps') && 'none' }}>
          2. Open {app}
        </div>}
        
      </div>
    );
  };

  if (app === 'Castro') {
    return (
      <div style={marginStyle}>
        {renderCopy()}
        <div style={showOnCopy}>
          <div>3. Tab the search icon at the bottom.</div>
          <div>4. Paste the URL.</div>
          {/* <div style={marginStyle}>  5. After subscribing, scroll down to{" "}
          <span style={{ backgroundColor: "transparent" }}>refresh</span>.
        </div> */}
        </div>
      </div>
    );
  } else if (app === 'Spotify') {
    return (
      <div style={marginStyle}>
        {renderCopy()}
        <div style={showOnCopy}>
          <div>2. <a href="https://podcasters.spotify.com/dash/submit" target='_blank'>Click here</a>, click Get Started, and paste the URL</div>
          <div>3. Check your email {userStore.user && `(${userStore.user.email}) `}for the forwarded verifiation code.</div>
          <div>4. Select any Location, Language, Category, etc. and Submit.</div>
          <div>5. Follow the channel!</div>

          {/* <div>
          6. After subscribing, scroll down to{" "}
          <span style={{ backgroundColor: "transparent" }}>refresh</span> if
          your episodes are not showing up.
        </div> */}
        </div>
      </div>
    );
  } else if (app === 'Apple Podcasts') {
    return (
      <div style={marginStyle}>
        {renderCopy()}
        <div style={showOnCopy}>
          {' '}
          <div>3. Tap the Library button.</div>
          <div>4. Tap Edit in the upper-right corner.</div>
          <div>5. Tap Add a Show by URL.</div>
          {/* <div>
          6. After subscribing, scroll down to{" "}
          <span style={{ back<div style={showOnCopy}></div>groundColor: "transparent" }}>refresh</span>.
        </div> */}
        </div>
      </div>
    );
  } else if (app === 'Downcast') {
    return (
      <div style={marginStyle}>
        {renderCopy()}
        <div style={showOnCopy}>
          {' '}
          <div>3. Tap the "Add" button at the bottom.</div>
          <div>4. Tap “Add Podcast Manually”</div>
          <div>5. Paste the URL.</div>
          {/* <div>
          6. After subscribing, scroll down to{" "}
          <span style={{ back<div style={showOnCopy}></div>groundColor: "transparent" }}>refresh</span>.
        </div> */}
        </div>
      </div>
    );
  } else if (app === 'Podbean') {
    return (
      <div style={marginStyle}>
        {renderCopy()}
        <div style={showOnCopy}>
          {' '}
          <div>3. Tap "Search" at the bottom.</div>
          <div>4. Tap "+Feed" in the upper-right corner.</div>
          <div>5. Paste your URL and subscribe.</div>
          {/* <div>
          6. After subscribing, scroll down to{" "}
          <span style={{ backgroundColor: "transparent" }}>refresh</span>.
        </div> */}
        </div>
      </div>
    );
  } else if (app === 'Castbox') {
    return (
      <div style={marginStyle}>
        {renderCopy()}
        <div style={showOnCopy}>
          {' '}
          <div>3. Tap the Discover bar at the top.</div>
          <div>4. Paste the URL in the search bar at the top.</div>
          <div>5. Hit Subscribe.</div>
          {/* <div> 
  6. After subscribing, scroll down to{" "}
  <span style={{ backgroundColor: "transparent" }}>refresh</span>.
</div> */}
        </div>
      </div>
    );
  } else if (app === 'Breaker') {
    return (
      <div style={marginStyle}>
        {renderCopy()}
        <div style={showOnCopy}>
          {' '}
          <div>3. Tap "Settings" at the bottom.</div>
          <div>4. Tap "Import OPML/RSS".</div>
          <div>5. Tap "Add private RSS feed".</div>
          <div>6. Paste your URL and subscribe.</div>
          {/* <div>
          6. After subscribing, scroll down to{" "}
          <span style={{ backgroundColor: "transparent" }}>refresh</span>.
        </div> */}
        </div>
      </div>
    );
  } else if (app === 'Airr') {
    return (
      <div style={marginStyle}>
        {renderCopy()}
        <div style={showOnCopy}>
          <div>3. Tap the "Search" icon at the top.</div>
          <div>4. Tab "Add RSS" in the upper-right corner.</div>
          <div>5. Paste your URL and subscribe.</div>

          {/* <div>
          6. After subscribing, scroll down to{" "}
          <span style={{ backgroundColor: "transparent" }}>refresh</span> if
          your episodes are not showing up.
        </div> */}
        </div>
      </div>
    );
  } else if (app === 'Google Podcasts') {
    return (
      <div style={marginStyle}>
        {renderCopy()}
        <div style={showOnCopy}>
          <div>3. Tap the "Activity" tab at the bottom.</div>
          <div>4. Tap "Subscriptions" tab at the top.</div>
          <div>5. Tab the three-dot icon in the upper-right corner.</div>
          <div>6. Tab "Add by RSS Feed".</div>
          <div>7. Paste the URL and subscribe.</div>

          {/* <div>
          6. After subscribing, scroll down to{" "}
          <span style={{ backgroundColor: "transparent" }}>refresh</span> if
          your episodes are not showing up.
        </div> */}
        </div>
      </div>
    );
  } else if (app === 'Pocket Casts') {
    return (
      <div style={marginStyle}>
        {renderCopy()}
        <div style={showOnCopy}>
          <div>3. Tap the "Discover" tab at the bottom.</div>
          <div>4. Paste the URL in the search bar and subscribe.</div>

          {/* <div>
          6. After subscribing, scroll down to{" "}
          <span style={{ backgroundColor: "transparent" }}>refresh</span> if
          your episodes are not showing up.
        </div> */}
        </div>
      </div>
    );
  } else if (app === 'The Podcast App') {
    return (
      <div style={marginStyle}>
        {renderCopy()}
        <div style={showOnCopy}>
          <div>3. Tap the "Search" tab at the bottom.</div>
          <div>4. Paste the URL in the search bar.</div>
          <div>5. Tap "Add private podcast."</div>

          {/* <div>
          6. After subscribing, scroll down to{" "}
          <span style={{ backgroundColor: "transparent" }}>refresh</span> if
          your episodes are not showing up.
        </div> */}
        </div>
      </div>
    );
  } else if (app === 'Other Apps') {
    return (
      <div style={marginStyle}>
        {renderCopy()}
        <div style={showOnCopy}>
          <div>2. Manually subscribe to the RSS URL using your app. </div>
          <div>
            Unsupported: Spotify, Stitcher, Pandora, TuneIn, and iHeartRadio
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
});

export default IosInstructions;
